import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';

function attachShadowIfEmpty(block: Blockly.Block, inputName: string): void {
    const input = block.getInput(inputName);
    if (!input?.connection || input.connection.targetBlock()) return;
    const shadow = (block.workspace as Blockly.WorkspaceSvg).newBlock('bool');
    shadow.setShadow(true);
    shadow.outputConnection?.connect(input.connection);
    requestAnimationFrame(() => {
        shadow.initSvg();
        shadow.render();
    });
}

defineBlock({
    type: 'logical_not',
    colour: CATEGORIES.operator.color,
    tooltip: '条件を反転します（NOTに）',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Boolean',
    inputs: [
        {
            kind: 'value',
            name: 'A',
            check: 'Boolean',
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'label',
                    text: 'が正しくない',
                },
            ],
        },
    ],
    onInit(this: Blockly.Block) {
        attachShadowIfEmpty(this, 'A');
    },
});
